<template>
  <div id="app">
    <!-- <div id="non-footer"> -->
    <nav class="navbar is-transparent main-navbar" role="navigation">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/" exact>
          <img src="./assets/logo.jpg" alt="Sharkey's Volleyball" width="110" height="110">
          <h1 class="title has-text-primary has-text-weight-normal is-size-5-mobile is-size-4-tablet is-size-3-desktop" style="padding-right: 0.25rem; padding-left: 0.25rem;">Sharkey's Volleyball</h1>
        </router-link>
        <div class="navbar-burger burger" @click="navExpanded = !navExpanded" :class="{'is-active': navExpanded}">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="navbar-menu is-transparent" :class="{'is-active': navExpanded}">
        <router-link class="navbar-item" to="/leagues" style="padding-right: 0.5rem; padding-left: 0.5rem;">
          <h3 class="subtitle has-text-primary has-text-weight-normal">
            Leagues
          </h3>
        </router-link>
        <router-link class="navbar-item" to="/tournaments" style="padding-right: 0.5rem; padding-left: 0.5rem;">
          <h3 class="subtitle has-text-primary has-text-weight-normal">
            Tournaments
          </h3>
        </router-link>
        <router-link class="navbar-item" to="/faqs" style="padding-right: 0.5rem; padding-left: 0.5rem;">
          <h3 class="subtitle has-text-primary has-text-weight-normal">
            FAQs
          </h3>
        </router-link>
        <router-link class="navbar-item" to="/gallery" style="padding-right: 0.5rem; padding-left: 0.5rem;">
          <h3 class="subtitle has-text-primary has-text-weight-normal">
            Gallery
          </h3>
        </router-link>
      </div>
    </nav>
    <router-view></router-view>
    <!-- </div> -->
    <!-- If we ever put a footer in, there's a solid amount of starter code here. -->
    <!-- <footer id="footer" class="footer">
      <address>
        The Beach At Sharkey's<br>
        7240 Oswego Rd<br>
        Liverpool, NY 13090
      </address>
      <a href="http://sharkeysbarandgrill.com/">Sharkey's Bar and Grill</a>
      <a href="https://www.facebook.com/SharkeysBeach">Facebook</a>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      navExpanded: false
    }
  }
}
</script>

<style lang="scss">

// Thanks to https://buefy.github.io/#/documentation/customization

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: lighten(saturate(green, 3%), 3%);
$primary-invert: findColorInvert($primary);
$external: #fd6301;
$external-invert: findColorInvert($external);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "external": ($external, $external-invert),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$navbar-height: 3.25rem;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbar-brand .navbar-item {
  font-family: 'Baloo Bhaijaan', cursive;
  padding: 0;
  img {
    height: $navbar-height;
    width: $navbar-height;
    max-height: initial;
    padding: 0.25rem;
  }
  h1 {
    font-size: 2rem !important;
    @media (max-width: 1024px) {
      font-size: 1.75rem !important;
    }
    @media (max-width: 500px) {
      font-size: 1.25rem !important;
    }
    @media (max-width: 375px) {
      font-size: 1rem !important;
    }
  }
}

nav.navbar.main-navbar {
  box-shadow: 0 1px 12px -2px $primary;
  background: linear-gradient(to left, lighten(transparentize($primary, 0.5), 50%), lighten(transparentize($primary, 0.75), 75%));
}
nav.navbar .navbar-item:hover, nav.navbar .router-link-active {
  background: linear-gradient(to right, lighten(transparentize($primary, 0.45), 62.5%), lighten(transparentize($primary, 0.55), 62.5%));
}
nav.navbar .navbar-item:focus {
  outline: none;
}
nav.navbar .navbar-brand {
  .navbar-item:hover, .router-link-active {
    background: transparent;
  }
}
nav.navbar .navbar-menu.is-active {
  background: transparent;
  box-shadow: none;
}

/* If we ever put a footer in, there's a solid amount of starter code here. */
/*
#non-footer {
  min-height: calc(100vh - 9.5rem);
  margin-bottom: 1.5rem;
}
*/

/* If we ever put a footer in, there's a solid amount of starter code here. */
/*
#footer {
  min-height: 5rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;

  > * {
    margin: 1rem;
  }

  address {
    text-align: left;
  }
}
*/
</style>
